// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_2deUg","Head":"Hero__Head_Dzfto","Title":"Hero__Title_2NXXp"};